import { module } from "modujs";
import VueCartTotal from "../vue/components/VueCartTotal";

export default class extends module {
    constructor(m) {
        super(m);

        // UI
        this.$el = this.el;
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        // Init vue
        this.initVue();
    }

    destroy() {
        super.destroy();
        this.app?.$destroy?.();
    }

    ///////////////
    // Methods
    ///////////////
    async getCheckoutUrl() {
        let checkoutUrl
        const cartId = localStorage.getItem(`cartId-${window.shopNamespace}`);

        if (cartId) {
            checkoutUrl = await CartApi.getCheckoutUrl(cartId);
        }

        if (window.isoCode) {
            checkoutUrl += `?locale=${window.isoCode}`
        }

        if (checkoutUrl) {
            window.location.href = checkoutUrl;
        }
    }

    updateTotal(cart) {
        if (!cart) return

        const isCheckoutAvailable = (cart.items.length > 0)

        // Update cart data
        requestAnimationFrame(() => {
            this.app && this.app.$refs.cartTotal && this.app.$refs.cartTotal.setCheckoutAvailability(isCheckoutAvailable)
            this.app && this.app.$refs.cartTotal && this.app.$refs.cartTotal.setTotalData(cart.total_price)
            this.app && this.app.$refs.cartTotal && this.app.$refs.cartTotal.updateUpsellProducts(cart.items)
        })
    }

    /////////////////////////
    // Vue Instance
    initVue() {
        /////////////////////////
        // Save moduleInstance
        const moduleInstance = this;

        /////////////////////////
        // Settings
        Vue.config.devtools = true;

        /////////////////////////
        // Vue Components
        VueCartTotal(moduleInstance);

        /////////////////////////
        // Vue Instance
        this.app = new Vue({
            el: this.el
        });
    }
}
